export default __webpack_public_path__ + "609f513c8b73fc726dcb30b40158f5cf.png";